import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { X} from 'lucide-react';
import { useToast } from "../components/ui/toast-provider";
import { useNavigate } from 'react-router';

import { UsuarioService } from "../services/usuarioService";

import { ChangePassResponse } from "../types/user";

export default function CrearAgente({ isOpen, onGuardado, onClose}: { isOpen: boolean; onGuardado: () => void; onClose: () => void}) {

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const { addToast } = useToast();

    const [formulario, setFormulario] = useState({
        contrasenaActual: '',
        nuevaContrasena: '',
        confirmarContrasena: '',
    });

    const resetFormulario = () => {
        setFormulario({
        contrasenaActual: '',
        nuevaContrasena: '',
        confirmarContrasena: '',
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (formulario.nuevaContrasena !== formulario.confirmarContrasena) {
            setError('Las contraseñas nuevas no coinciden');
            return;
        }

        try {
            const payload: ChangePassResponse = {
                password_actual: formulario.contrasenaActual,
                password_nueva: formulario.nuevaContrasena
            };
            // Intentar cambiar la contraseña
            await UsuarioService.cambiarContrasena(payload);

            addToast("Contraseña actualizada exitosamente");
            resetFormulario();
            onGuardado();
        } catch (err:any) {
              const message =
                err?.response?.data?.message ||
                "Error inesperado al guardar contraseña";

            setError(message);
        }
    }

    useEffect(() => {
        if(isOpen) {
            resetFormulario();
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
            <div className="rounded-2xl w-full max-w-2xl shadow-lg relative max-h-[90vh] overflow-y-auto scrollbar-thin">
                <Card>
                    <CardHeader className="flex flex-row items-center justify-between">
                        <CardTitle>{'Cambiar Contraseña'}</CardTitle>
                        <button
                        onClick={onClose}
                        className="p-2 hover:bg-destructive/10 rounded-lg transition-colors"
                        >
                        <X className="w-5 h-5 text-destructive" />
                        </button>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                            <Input
                            label="Contraseña Actual"
                            type="password"
                            value={formulario.contrasenaActual}
                            onChange={(e) =>
                                setFormulario({ ...formulario, contrasenaActual: e.target.value })
                            }
                            placeholder="Ingrese su contraseña actual"
                            required
                            />
                            <Input
                            label="Nueva Contraseña"
                            type="password"
                            value={formulario.nuevaContrasena}
                            onChange={(e) =>
                                setFormulario({ ...formulario, nuevaContrasena: e.target.value })
                            }
                            placeholder="Ingrese su nueva contraseña (mínimo 8 caracteres)"
                            required
                            />
                            <Input
                            label="Confirmar Nueva Contraseña"
                            type="password"
                            value={formulario.confirmarContrasena}
                            onChange={(e) =>
                                setFormulario({ ...formulario, confirmarContrasena: e.target.value })
                            }
                            placeholder="Confirme su nueva contraseña"
                            required
                            />
                        </div>
                        <div className = "flex justify-center">
                        {error && (
                            <span className="text-destructive text-center text-sm">{error}</span>
                        )}
                        </div>
                        <div className="flex gap-2">
                            <Button type="submit" variant="primary">
                            {'Editar Contraseña'}
                            </Button>
                            <Button type="button" variant="ghost" onClick={onClose}>
                            Cancelar
                            </Button>
                        </div>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </div>
    )

}